import { StoreActionApi, BoundActions as _BoundActions } from "react-sweet-state";
import { WPPost, GlobalData, WPTaxTerm, SortModes } from "../../constants/types";
import {
    ChallengingSituationsACF,
    ConditionPostTypeACF,
    LocalInformationPostTypeACF,
    // LocalListingPostTypeACF,
    PopulationPostTypeACF,
    ListingAcf,
} from "../../constants/types/acf";
import { actions } from "./actions";

export enum PopupStates {
    PENDING,
    OPENED,
    CLOSED,
}

export type NotificationBar = {
    enabled: boolean;
    content: string;
    hasUserClosed: boolean;
};

export type UIState = {
    sortMode: SortModes;
    locationAccessDenied: boolean;
    showingFreeServices: boolean;
    showingAssetmentFilter: boolean;
    outsideAuPopup: PopupStates;
    legacyBrowserPopup: PopupStates;
    notificationBar: NotificationBar;
};

export type State = {
    global: GlobalData;
    routes: { [key: string]: WPPost | void };
    showingRegionSelect: boolean;
    // UI State
    ui: UIState;

    // Post type data
    populations: WPPost<PopulationPostTypeACF>[];
    conditions: WPPost<ConditionPostTypeACF>[];
    localInformation: WPPost<LocalInformationPostTypeACF>[];
    featuredServices: WPPost<ListingAcf>[];
    servicesInRegion: WPPost<ListingAcf>[];
    challengingSituations: WPPost<ChallengingSituationsACF>[];

    // Taxonomy Data
    taxCommunities: WPTaxTerm[];
    taxConditionsNeeds: WPTaxTerm[];
    taxSituations: WPTaxTerm[];
    taxGenders: WPTaxTerm[];
};

export type StoreApi = StoreActionApi<State>;

export type Actions = typeof actions;

export type BoundActions = _BoundActions<State, Actions>;
